export default "__VITE_ASSET__BPnzkvwe__"